export const BORA_THEMES = ['tuuleliinid', 'kihnu', 'sark', 'trial'] as const

const tuuleliinid = BORA_THEMES[0]
const kihnu = BORA_THEMES[1]
const sark = BORA_THEMES[2]
// The Try Now white-label storefront: one deployment for every trial tenant, no branding
const trial = BORA_THEMES[3]

export { tuuleliinid, kihnu, sark, trial }
